import $api from "../api";
// import Swal from "sweetalert2";

export const state = {
    data: {
        list: [],
        links: [],
        current_page: 0,
        last_page: 0,
        per_page: 0,
        total: 0,
    },
};

export const actions = {
    getAll({ rootGetters }, pl) {
        return new Promise(function (resolve) {
            $api
                .get(`chapters`, {
                    headers: { Authorization: rootGetters["auth/bearer_token"] },
                    params: pl,
                })
                .then(function (res) {
                    if (res.status == 200) resolve(res.data);
                })
                .catch(function (err) {
                    if (!err.response) { resolve(null); return; }
                });
        });
    },
};

export const mutations = {
    setData(state, data) {
        state.data.list = data.data;
        state.data.links = data.links;
        state.data.current_page = data.current_page;
        state.data.last_page = data.last_page;
        state.data.per_page = data.per_page;
        state.data.total = data.total;
    },
    clearData(state) {
        state.data.list = [];
        state.data.links = [];
        state.data.current_page = 0;
        state.data.last_page = 0;
        state.data.per_page = 0;
        state.data.total = 0;
    },
};

export const getters = {};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
